<template>
  <div class="">


    <!-- Hello::: {{ this.userInfo.user.permission }} -->

    <div class="w-full h-full fixed top-0 left-0 -z-10 bg-[#e5e7eb]"></div>
    <!-- <Header /> -->
    <!-- <component :is="HeaderComponent" /> -->

    <div class="p-5 lg:p-10">
      <div class="flex gap-3 items-center">
        <button
          v-for="attendance in attendance_list"
          :key="attendance"
          :class="{
            'text-white bg-[#18469d]': active_tab === attendance,
            'text-black border border-[#98a0ac]': active_tab != attendance,
          }"
          class="px-6 py-1.5 capitalize rounded-md cursor-pointer"
          @click="active_tab = attendance"
        >
          {{ attendance }}
        </button>
      </div>
      <div v-if="active_tab == 'attendance'">
        <TodayView />
      </div>
      <div v-if="active_tab == 'stats'">
        <AttendanceStats />
      </div>
      <div v-if="active_tab == 'list'">
        <AttendanceList />
      </div>
    </div>
  </div>
</template>

<script>
// import Header from "@/components/Instructor/Header.vue";
import AttendanceList from "@/components/Instructor/Attendance/AttendanceList.vue";
import TodayView from "@/components/Instructor/Attendance/TodayView.vue";
import AttendanceStats from "@/components/Instructor/Attendance/AttendanceStats.vue";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      attendance_list: ["attendance", "stats", "list"],
      active_tab: "attendance",
      // HeaderComponent: null,
    };
  },
  components: {
    TodayView,
    AttendanceStats,
    AttendanceList,
  },

  created(){
    // setTimeout(()=>{
    //   if (this.userInfo.user.permission === 'instructor') {
    //     // console.log("user info::");
    //     const module = import('@/components/Instructor/Header.vue')
    //     console.log(module, "module::");
    //     this.HeaderComponent = module.default;
    //   };
    // }, 100)
    
  },
  computed: mapGetters(["userInfo"]),
};
</script>

<style></style>
